import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Button from '@mui/material/Button';
import { useIntl } from 'react-intl';

import { i18n } from './PdsLinkButton.i18n';

const PDS_CAPACITY_GROUP_BASE_URL = 'https://pds.seequent.com/capacity_groups/';

type PdsLinkButtonProps = {
    capacityGroupId: string;
};

export const PdsLinkButton = ({ capacityGroupId }: PdsLinkButtonProps) => {
    const intl = useIntl();
    const trimmed = capacityGroupId.trim();

    return (
        <Button
            component="a"
            href={`${PDS_CAPACITY_GROUP_BASE_URL}${encodeURIComponent(trimmed)}`}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            startIcon={<OpenInNewIcon />}
            automation-id="pds-navigate-button"
        >
            {intl.formatMessage(i18n.navigateToPds)}
        </Button>
    );
};
